import "./about.css";

export function About() {
  return (
    <section id="about" className="section alt">
      <div className="container">
        <h3>Sobre nosotros</h3>
        <p className="about-txt">
          <strong>Somos una empresa familiar con años de experiencia</strong> en poda, extracción 
          y mantenimiento de árboles. 
          Priorizamos la <strong>seguridad</strong>, la <strong>limpieza</strong> y la 
          <strong> satisfacción</strong> del cliente.
          <br></br><br></br>
          Nos destacamos por nuestro compromiso con la <strong>calidad</strong>, 
          el <strong>cuidado del medio ambiente</strong>, la <strong>rapidez del trabajo</strong> y la <strong>atención personalizada</strong>. 
          <br /><br />
          Nuestro equipo de <strong>profesionales capacitados </strong>
          garantiza resultados excepcionales en cada proyecto, adaptándonos a las
          necesidades específicas de cada cliente.
        </p>
      </div>
    </section>
  );
}